




















































































































import { mapState, mapActions, mapGetters } from 'vuex'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import Facet from '~/components/car/classifieds/search/facets/Facet.vue'
import FacetsModal from './FacetsModal.vue'
import MapLocationSearchHandler from '~/components/car/classifieds/search/facets/handlers/MapLocationSearchHandler.vue'
import { facetChanged } from '~/store/modules/shared/classifieds/search/action-types'
import { mapDeps } from '~/plugins/dependency-container/utils'
import ClassifiedSearchFacetsComponentsService from '~/services/search/ClassifiedSearchFacetsComponentsService'
import { debounce } from '~/utils/function'
import { DEBOUNCE_DEFAULT } from '~/constants/debounce'
import { defineComponent } from '@nuxtjs/composition-api'

const MAIN_FACETS_NUMBER = 3

export default defineComponent({
  components: {
    Facet,
    FacetsModal,
    MapLocationSearchHandler
  },
  props: {
    facets: { type: Array, required: true },
    isMobile: { type: Boolean, default: false }
  },
  data() {
    return {
      facetName: null,
      isMoreFilterModalVisible: false,
      visibleFacet: null,
      isDropdownExpanded: false,
      isDatepickerVisible: false,
      allowCDropdownAutoHide: true
    }
  },
  computed: {
    ...mapState(CLASSIFIED_SEARCH_NS, {
      rows: state => state.rows,
      isFacetLoading: state => state.loading.facets,
      totalClassifieds: state => state.pagination.total,
      query: state => state.currentRoute.query,
      params: state => state.params
    }),
    ...mapGetters(CLASSIFIED_SEARCH_NS, {
      inPlotSearch: 'inPlotSearch'
    }),
    ...mapDeps({
      classifiedSearchFacetsComponentsService: ClassifiedSearchFacetsComponentsService
    }),
    ...mapGetters(CLASSIFIED_SEARCH_NS, {
      showSellers: 'showSellers'
    }),

    visibleFacets(): [] {
      return this.facets.filter(
        f =>
          f.visible &&
          this.classifiedSearchFacetsComponentsService.getFacetComponent(
            f.type
          ) &&
          f.name !== 'postcode' &&
          f.name !== 'location'
      )
    },
    mainFacets(): [] {
      if (this.inPlotSearch) {
        return this.visibleFacets.slice(0, MAIN_FACETS_NUMBER)
      }
      return this.visibleFacets.slice(0, MAIN_FACETS_NUMBER + 1)
    },
    locationSearchFacet() {
      return this.facets.find(f => f.name === 'location')
    },
    moreFacetsNumberOfSelected(): number {
      return this.visibleFacets.filter(m => m.isSelected).length
    },
    renderedHandler() {
      if (this.visibleFacets.length > 0) {
        return this.visibleFacets.find(f => f.name === this.facetName)
      }
      return null
    },
    isStudenButtonSelected(): boolean {
      const { category, specials } = this.query
      if (Array.isArray(category) && category?.length && specials === '25') {
        return category.filter(c => ['20014', '20015'].includes(c)).length === 2
      }

      return false
    },
    rentalPeriodFacetName() {
      return 'rental_period'
    },
    makemodelFacetName() {
      return 'makemodel'
    },
    pickupLocationFacetName() {
      return 'pickup_location'
    }
  },
  methods: {
    ...mapActions(CLASSIFIED_SEARCH_NS, {
      clearFacet: 'clearFacet',
      facetChanged
    }),
    ...mapActions(CLASSIFIED_SEARCH_NS, {}),
    renderHandler(facetName: string) {
      this.facetName = facetName
    },
    showMore() {
      this.isMoreFilterModalVisible = true
    },
    handleFacetVisibilityToggle(facetName: string, visible: boolean) {
      if (facetName === this.rentalPeriodFacetName) {
        this.handleDatepickerToggle(visible)
      } else if (facetName === this.makemodelFacetName) {
        if (!visible) {
          this.handleLocationChange()
        } else {
          this.allowCDropdownAutoHide = !visible
        }
      }
    },
    handleDatepickerToggle(status: boolean) {
      if (!this.isDatepickerVisible) {
        this.isDropdownExpanded = true
      }
      this.debouncedToggleDatePicker(status)
    },
    debouncedToggleDatePicker: debounce(function(status: boolean) {
      this.isDropdownExpanded = status
      this.isDatepickerVisible = status
    }, DEBOUNCE_DEFAULT),
    handleClearFacet(name: string) {
      this.clearFacet({ name })
    },
    handleStudentClick() {
      if (this.isStudenButtonSelected) {
        this.facetChanged({
          params: [
            { name: 'category', value: null },
            { name: 'specials', value: null }
          ]
        })
      } else {
        this.facetChanged({
          params: [
            { name: 'category', value: [20014, 20015] },
            { name: 'specials', value: 25 }
          ]
        })
      }
    },
    handleLocationChange() {
      this.allowCDropdownAutoHide = false
      setTimeout(() => (this.allowCDropdownAutoHide = true), 300)
    }
  }
})
